var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('filter-select',{ref:"taskSelect",attrs:{"id":"taskSelect","placeholder":_vm.$t('task.name'),"multiple":false,"selected":_vm.selectedItem},on:{"filter":_vm.itemSearch,"changed":_vm.itemSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }